import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '../../Button';
import VacationSvg from './vacation.svg';
import './VacationPopup.css';

export const VacationPopup = ({ handleTurnOffVacationMode }) => (
  <div className="vacation-popup-content">
    <div className="vacation-popup-content__image-container">
      <img
        alt="Managed"
        className="vacation-popup-content__image-container__image"
        src={VacationSvg}
      />
    </div>
    <div className="vacation-popup-content__body">
      <div className="portfolio-popup-content__body__title">
        You&apos;re currently set to <br />
        vacation mode
      </div>
    </div>
    <div className="vacation-popup-content__action">
      <Button
        id="vacation-popup-upload-button"
        className="vacation-popup-content__action--upload"
        textClassName="vacation-popup-content__action--upload-text"
        onClick={handleTurnOffVacationMode}
        rounded
        block
        title="Turn off vacation mode"
      />
    </div>
  </div>
);

VacationPopup.propTypes = {
  handleTurnOffVacationMode: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Popup/VacationPopup/VacationPopup.js